import apiClient from '@/api/apiClient.js';
import router from '../../../router/index.js';
import {
  getInstProfesId,
  getPatientsId,
} from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    catDepartments: [],
    catProvinces: [],
    catDistricts: [],
    modelForm: {},
    dataCrud: [],
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    catDepartments(state) {
      return state.catDepartments;
    },
    catProvinces(state) {
      return state.catProvinces;
    },
    catDistricts(state) {
      return state.catDistricts;
    },
    modelForm(state) {
      return state.modelForm;
    },
    dataCrud(state) {
      return state.dataCrud;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertModelForm(state, modelForm) {
      state.modelForm = modelForm;
    },
    insertCatDepartments(state, catDepartments) {
      state.catDepartments = catDepartments;
    },
    insertCatProvinces(state, catProvinces) {
      state.catProvinces = catProvinces;
    },
    insertCatDistricts(state, catDistricts) {
      state.catDistricts = catDistricts;
    },
    insertDataCrud(state, dataCrud) {
      state.dataCrud = dataCrud;
    },
    saveData(state) {
      state.status = 'success';
    },
    saveError(state) {
      state.status = 'error';
    },
    transf(state, msgTransf) {
      state.status = msgTransf;
    },
    transfError(state) {
      state.status = 'error';
    },
    assim(state, msgAssim) {
      state.status = msgAssim;
    },
    assimError(state) {
      state.status = 'error';
    },
    saveHCP(state) {
      state.status = 'success';
    },
    errorHCP(state, msgError) {
      state.status = msgError;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proPatientsCSchema();
        const schema = res.data;

        const resCat1 = await apiClient.catBirthSexes();
        const catBirthSexes = resCat1.data.data;

        const resCat2 = await apiClient.catISO3366_1();
        const catISO3366_1 = resCat2.data.data;

        const resCat3 = await apiClient.catDepartments();
        const catDepartments = resCat3.data.data;

        const resCat6 = await apiClient.catYear();
        const catYear = resCat6.data.data;

        schema.schemaForm.birth_sexes_birth_sexes_id.items = catBirthSexes;
        schema.schemaForm.users_birth_iso3366.items = catISO3366_1;
        schema.schemaForm.users_birth_department.items = catDepartments;
        schema.schemaForm.users_birth_date_year.items = catYear;

        schema.schemaFormNoEdit.birth_sexes_birth_sexes_id.items = catBirthSexes;
        schema.schemaFormNoEdit.users_birth_iso3366.items = catISO3366_1;
        schema.schemaFormNoEdit.users_birth_department.items = catDepartments;
        schema.schemaFormNoEdit.users_birth_date_year.items = catYear;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadCatDepartments({ commit }) {
      try {
        const res = await apiClient.catDepartments();
        const catDepartments = res.data.data;
        commit('insertCatDepartments', catDepartments);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadCatProvinces({ commit }) {
      try {
        const res = await apiClient.catProvinces();
        const catProvinces = res.data.data;
        commit('insertCatProvinces', catProvinces);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadCatDistricts({ commit }) {
      try {
        const res = await apiClient.catDistricts();
        const catDistricts = res.data.data;
        commit('insertCatDistricts', catDistricts);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadModelForm({ commit }, payload) {
      try {
        const id = getPatientsId();
        if (!id) {
          if (confirm('Buscar y elegir al paciente. Se le redirigirá hacia el buscador.')) {
            router.push({ name: 'patients-b' });
          }
        } else {
          let model = {};
          if (payload === undefined) {
            model.usersPin = false;
          } else {
            const usersPin = payload.usersPin;
            model.usersPin = usersPin;
          }

          const res = await apiClient.modelProPatientsC(id, model);
          const modelForm = res.data.data;
          commit('insertModelForm', modelForm);
        }
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadDataCrud({ commit }) {
      try {
        const id1 = getPatientsId();
        const id2 = getInstProfesId();
        const res = await apiClient.dataCrudProPatientsC(id1, id2);
        const dataCrud = res.data.data;

        for (let i = 0; i < dataCrud.length; i++) {
          let instProfesId1 = dataCrud[i].instProfes_id;
          let instProfesId2 = getInstProfesId();
          if (instProfesId1 === instProfesId2) {
            dataCrud[i].institutions_has_profes_npro = 'Usted';
          }
        }

        commit('insertDataCrud', dataCrud);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async saveForm({ commit }, model) {
      try {
        const id = getPatientsId();
        const res = await apiClient.updateProPatientsC(id, model);
        let data = {};
        data.statusText = res.statusText;
        commit('saveData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error guardando');
        commit('saveError');
        throw error;
      }
    },
    async transfer({ commit }, model) {
      try {
        const id = getPatientsId();
        const res = await apiClient.proTransfers(id, model);
        const msgTransf = res.data.data;
        commit('transf', msgTransf);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error transfiriendo');
        commit('transfError');
        throw error;
      }
    },
    async assimilate({ commit }, model) {
      try {
        const id = getPatientsId();
        const res = await apiClient.proAssimilate(id, model);
        const msgAssim = res.data.data;
        commit('assim', msgAssim);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error asimilando');
        commit('AssimError');
        throw error;
      }
    },
    async createHCP({ commit, rootState }, versionAN) {
      try {
        const newClinicalHistories = {
          instProfes_id: rootState.auth.authData.institutions_profes_id,
          patients_id: rootState.auth.authData.patients_id,
          versionAN: versionAN,
        };

        const res = await apiClient.createClinicalHistories(newClinicalHistories);
        let dataHCP = {};
        dataHCP.statusText = res.statusText;
        commit('saveHCP', dataHCP);
      } catch (e) {
        console.error('Error creando hcp');
        const msgError = e.response?.data.message;

        commit('errorHCP', msgError);
        throw e;
      }
    },

    async summaryHCP({ commit }, item) {
      try {
        const instProfesId = getInstProfesId();
        const clinicalHistoriesId = item.clinicalHistories_id;
        const clinicalHistoriesHCPnum = item.clinicalHistories_hcp;

        const res = await apiClient.proSummaryHCP(clinicalHistoriesId, instProfesId);
        const url = window.URL.createObjectURL(new Blob([res.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `HCP-${clinicalHistoriesHCPnum}.pdf`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        link.remove();
      } catch (e) {
        console.error(e);
        commit('transfError');
        throw e;
      }
    },

    async exportHCP({ commit }, item) {
      try {
        const instProfesId = getInstProfesId();
        const clinicalHistoriesId = item.clinicalHistories_id;
        const clinicalHistoriesHCPnum = item.clinicalHistories_hcp;
        
        const res = await apiClient.proExportHCP(clinicalHistoriesId, instProfesId);
        const url = window.URL.createObjectURL(new Blob([res.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `HCP-${clinicalHistoriesHCPnum}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error(e);
        commit('transfError');
      }
    },
  },
};
